
<template>
  <div>
    <div class="faq-area default-padding bg-gray">
        <div class="container">
            <div class="faq-items">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="faq-content">
                            <div id='crmWebToEntityForm' style='width:700px;margin:auto;'>
                                <form :action="cons.links.crm.zohoWebToLead" name=WebToLeads4597277000000424081 method='POST' onSubmit='javascript:document.charset="UTF-8"; return checkMandatory4597277000000424081()' accept-charset='UTF-8'>
                                    <input type='text' style='display:none;' name='xnQsjsdp' value='85cf64b4563be8a1ac04a0934e743ac0a01c0fa4b55e1ddb70f464b1ecc83e50' />
                                    <input type='hidden' name='zc_gad' id='zc_gad' value='' />
                                    <input type='text' style='display:none;' name='xmIwtLD' value='786c9b916bcaa377d071c5d975bd04da1e279152eb5244e71bdad0b5ecf472c6' />
                                    <input type='text'  style='display:none;' name='actionType' value='TGVhZHM=' />
                                    <input type='text' style='display:none;' name='returnURL' :value='cons.links.vapp.edigReturnUrl'  /><br />
                                    <!-- Do not remove this code. -->
                                    <input type='text' style='display:none;' id='ldeskuid' name='ldeskuid' />
                                    <input type='text' style='display:none;' id='LDTuvid' name='LDTuvid' />
                                    <!-- Do not remove this code. -->
                                    <table style='width:700px;background-color:#ffffff;background-color:white;color:black'>
                                        <tr>
                                            <td colspan='2' align='left' style='color:black;font-family:Arial;font-size:17px;word-break: break-word;'>
                                                <strong>Formulario Cliente Nuevo</strong>
                                            </td>
                                        </tr> 
                                        <br />
                                        <tr>
                                            <td style='word-break: break-word;text-align:left;font-size:15px;font-family:Arial;width:30%;'>
                                                Empresa<span style='color:red;'>*</span>
                                            </td>
                                            <td style='width:40%;' ><input type='text' style='width:100%;box-sizing:border-box;'  maxlength='100' name='Company' /></td><td style='width:30%;'></td></tr><tr><td  style='word-break: break-word;text-align:left;font-size:15px;font-family:Arial;width:30%;'>RUT CLIENTE<span style='color:red;'>*</span></td><td style='width:40%;' ><input type='text' style='width:100%;box-sizing:border-box;'  maxlength='255' name='LEADCF3' /></td><td style='width:30%;'></td></tr><tr><td  style='word-break: break-word;text-align:left;font-size:15px;font-family:Arial;width:30%;'>Nombre Contacto</td><td style='width:40%;' ><input type='text' style='width:100%;box-sizing:border-box;'  maxlength='40' name='First Name' /></td><td style='width:30%;'></td></tr><tr><td  style='word-break: break-word;text-align:left;font-size:15px;font-family:Arial;width:30%;'>Apellidos<span style='color:red;'>*</span></td><td style='width:40%;' ><input type='text' style='width:100%;box-sizing:border-box;'  maxlength='80' name='Last Name' /></td><td style='width:30%;'></td></tr><tr><td  style='word-break: break-word;text-align:left;font-size:15px;font-family:Arial;width:30%;'>Correo electrónico<span style='color:red;'>*</span></td><td style='width:40%;' ><input type='text' style='width:100%;box-sizing:border-box;'  maxlength='100' name='Email' ftype='email'/></td><td style='width:30%;'></td></tr><tr><td  style='word-break: break-word;text-align:left;font-size:15px;font-family:Arial;width:30%;'>M&oacute;vil</td><td style='width:40%;' ><input type='text' style='width:100%;box-sizing:border-box;'  maxlength='30' name='Mobile' /></td><td style='width:30%;'></td></tr><tr><td  style='word-break: break-word;text-align:left;font-size:15px;font-family:Arial;width:30%;'>Tipo Cliente<span style='color:red;'>*</span></td><td style='width:40%;'>
                                        <select style='width:100%;box-sizing:border-box;' name='LEADCF4'>
                                            <option value='-None-'>-None-</option>
                                            <option value='Nuevo'>Nuevo</option>
                                            <option value='Renovaci&oacute;n'>Renovaci&oacute;n</option>
                                        </select>
                                    </td>
                                    <td style='width:30%;'></td></tr><tr><td  style='word-break: break-word;text-align:left;font-size:15px;font-family:Arial;width:30%;'>Requiere Migración<span style='color:red;'>*</span></td><td style='width:40%;'>
                                    <select style='width:100%;box-sizing:border-box;' name='LEADCF5'>
                                    <option value='-None-'>-None-</option>
                                    <option value='Si'>Si</option>
                                    <option value='No'>No</option>
                                    </select></td><td style='width:30%;'></td></tr><tr><td  style='word-break: break-word;text-align:left;font-size:15px;font-family:Arial;width:30%;'>Cantidad de Aplicaciones<span style='color:red;'>*</span></td><td style='width:40%;' ><input type='text' style='width:100%;box-sizing:border-box;'  maxlength='9' name='LEADCF52' /></td><td style='width:30%;'></td></tr><tr><td  style='word-break: break-word;text-align:left;font-size:15px;font-family:Arial;width:30%;'>Cantidad de Usuarios<span style='color:red;'>*</span></td><td style='width:40%;' ><input type='text' style='width:100%;box-sizing:border-box;'  maxlength='9' name='LEADCF51' /></td><td style='width:30%;'></td></tr><tr><td  style='word-break: break-word;text-align:left;font-size:15px;font-family:Arial;width:30%;'>Nombre Vendedor Edig<span style='color:red;'>*</span></td><td style='width:40%;'>
                                    <select style='width:100%;box-sizing:border-box;' name='LEADCF1'>
                                    <option value='-None-'>-None-</option>
                                    <option value='Camila&#x20;Pino'>Camila Pino</option>
                                    <option value='Catalina&#x20;Lorca'>Catalina Lorca</option>
                                    <option value='Claudia&#x20;Vieytes'>Claudia Vieytes</option>
                                    <option value='Constanza&#x20;Fuentes'>Constanza Fuentes</option>
                                    <option value='Dayana&#x20;Villamizar'>Dayana Villamizar</option>
                                    <option value='Enrique&#x20;Guerra'>Enrique Guerra</option>
                                    <option value='Ivo&#x20;Pierotic'>Ivo Pierotic</option>
                                    <option value='Katherine&#x20;Orrego'>Katherine Orrego</option>
                                    <option value='Katia&#x20;Pino'>Katia Pino</option>
                                    <option value='Maria&#x20;Loreto&#x20;Guajardo'>Maria Loreto Guajardo</option>
                                    <option value='Mar&iacute;a&#x20;Luisa&#x20;Cruz'>Mar&iacute;a Luisa Cruz</option>
                                    <option value='Maritza&#x20;P&eacute;rez'>Maritza P&eacute;rez</option>
                                    <option value='Patricia&#x20;Cavieres'>Patricia Cavieres</option>
                                    <option value='Patricio&#x20;Aldunate'>Patricio Aldunate</option>
                                    <option value='Pedro&#x20;Rodr&iacute;guez'>Pedro Rodr&iacute;guez</option>
                                    <option value='Roberto&#x20;Contreras'>Roberto Contreras</option>
                                    </select></td><td style='width:30%;'></td></tr>
                                    
                                    <tr><td colspan='2' style='text-align:center; padding-top:15px;font-size:15px;'>
                                    <input style='margin-right: 5px;cursor: pointer;font-size:15px;color:#000000' id='formsubmit' type='submit' value='Enviar'  /> <input type='reset' name='reset' style='cursor: pointer;font-size:15px;color:#000000' value='Restablecer'  /> </td></tr></table>
                            
                            
                                    <input type='hidden' name='eo' value='14f4ec16431e0686150daa43f3210513'/> <input type='hidden' name='te' value='true'/><img id='tr_img_786c9b916bcaa377d071c5d975bd04da1e279152eb5244e71bdad0b5ecf472c6' :src="cons.links.crm.zohoAnalyticsTracker" style='display: none;' /></form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
    <bannerFooter/>
  </div>
</template>

<script>
        var mndFileds=new Array('Company','Last Name','Email','LEADCF3','LEADCF4','LEADCF5','LEADCF1','LEADCF51','LEADCF52');
        var fldLangVal=new Array('Empresa','Apellidos','Correo electrónico','RUT CLIENTE','Tipo Cliente','Requiere Migración','Nombre Vendedor Edig','Cantidad de Usuarios','Cantidad de Aplicaciones');
        var name='';
        var email='';
        function validateEmail()
        {
        var emailFld = document.querySelectorAll('[ftype=email]');
        var i;
        for (i = 0; i < emailFld.length; i++)
        {
        var emailVal = emailFld[i].value;
        if((emailVal.replace(/^\s+|\s+$/g, '')).length!=0 )
        {
        var atpos=emailVal.indexOf('@');
        var dotpos=emailVal.lastIndexOf('.');
        if (atpos<1 || dotpos<atpos+2 || dotpos+2>=emailVal.length)
        {
        alert('Introduzca una dirección de correo electrónico válida. ');
        emailFld[i].focus();
        return false;
        }
        }
        }
        return true;
        }
        
            function checkMandatory4597277000000424081() {
        for(i=0;i<mndFileds.length;i++) {
        var fieldObj=document.forms['WebToLeads4597277000000424081'][mndFileds[i]];
        if(fieldObj) {
        if (((fieldObj.value).replace(/^\s+|\s+$/g, '')).length==0) {
        if(fieldObj.type =='file')
        {
        alert('Seleccione un archivo para cargar.');
        fieldObj.focus();
        return false;
        }
        alert(fldLangVal[i] +' no puede estar vacío.');
                fieldObj.focus();
                return false;
        }  else if(fieldObj.nodeName=='SELECT') {
            if(fieldObj.options[fieldObj.selectedIndex].value=='-None-') {
        alert(fldLangVal[i] +' no puede ser nulo.');
        fieldObj.focus();
        return false;
        }
        } else if(fieldObj.type =='checkbox'){
        if(fieldObj.checked == false){
        alert('Please accept  '+fldLangVal[i]);
        fieldObj.focus();
        return false;
        }
        }
        try {
            if(fieldObj.name == 'Last Name') {
        name = fieldObj.value;
            }
        } catch (e) {}
            }
        }
        trackVisitor();
        if(!validateEmail()){return false;}
        
        }
        
    import bannerFooter from '../components/BannerFooter'

    import axios from "axios"
    import cons from '@/utils/const'
    export default {
        name: "Edig",
        components: {
            bannerFooter
        },
        data () {
            return {
                cons,
            }
        },
        beforeMount() {},
        methods: {
        }
    };
</script>

<style scope>
#crmWebToEntityForm tr , #crmWebToEntityForm td {
    padding:6px;
    border-spacing:0px;
    border-width:0px;
    }
</style>